export default {
  loggedIn: false,
  newClient: false,
  data: {
    client_id: 0,
    user_id: 0,
    first_name: '',
    last_name: '',
    email_address: '',
    gender: '',
    date_of_birth: '',
    phone_number: '',
    nationality: null,
    national_id: '',
    id_type: '',
    title: '',
    marital_status: '',
    residential_address: '',
    token: ''
  }
}